<template>
  <div class="tes-card pa-7 fill-weight">
    <h1 class="tes-card__title">
      {{ $t("pages.paymentsCurrent.title") }}
    </h1>

    <v-row no-gutters class="my-4">
      <v-col cols="12" sm="9">
        <div class="d-flex flex-wrap">
          <span
            class="mr-3 fs-18 d-inline-block mt-1"
            :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'"
            >{{ $t("personalAccount") }}:</span
          >
          <personal-account-select
            class="d-inline-block"
            :onlyIsOwner="false"
            :disabled="loading || !isOnline"
          ></personal-account-select>
        </div>
      </v-col>
      <div class="flex-grow-1"></div>
      <v-col
        v-if="currentReceipt.year && currentReceipt.month"
        cols="12"
        sm="3"
        class="text-right tes-green-text helvetica-medium fs-20"
      >
        <div>{{ currentReceipt | humanReadableDate }}</div>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="9">
        <loader-wrapper :loading="loading" :min-height="windowSize.x < 756 ? 30 : 500" :showNoDataText="showNoDataText">
          <viewer
            v-if="receiptImageSource"
            :images="[receiptImageSource]"
            :options="{ navbar: false, toolbar: false }"
            class="cursor_pointer"
          >
            <img :src="receiptImageSource" class="white tes-card receipt-image" alt="Квитанция" />
          </viewer>
        </loader-wrapper>
      </v-col>
      <v-col class="text-center ml-7" :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">
        <span class="text-left pr-3 mt-3 mt-sm-0" :class="currentLocale === 'ru' ? 'helvetica-bold' : 'rubik-bold'">
          {{ $t("pages.paymentsCurrent.sum") }}</span
        >
        <div>
          <span class="pr-3"></span>
          <span class="helvetica-bold tes-green-text fs-20">{{ prePayment }}</span>
          <span class="rub-postfix d-inline-block px-3">{{ $t("currency") }}.</span>
        </div>
        <div>
          <span class="mt-3 fs-14">{{ $t("pages.paymentsCurrent.edit") }}</span>
        </div>
        <div class="mt-3">
          <v-btn
            :disabled="!receiptPdf || !isOnline"
            class="d-inline-block orange-button"
            :class="{ 'button-font': currentLocale === 'tat' }"
            width="150"
            @click="doPay()"
            :loading="loading"
            >{{ $t("buttons.pay") }}</v-btn
          >
        </div>

        <div class="vtb-button-cont my-8">
          <span class="mt-3 fs-14">
            {{$t('modals.modalPaymentNew.vtbInfoPart1')}} {{$t('modals.modalPaymentNew.vtbInfoPart2')}} {{$t('modals.modalPaymentNew.vtbInfoPart3')}}
          </span>
          <div class="mt-3">
            <v-btn class="mb-5 vtb-button"
                   @click="GetVTBUrl()"
                   width="150">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <circle cx="12" cy="12" r="11" fill="white" />
                <g transform="translate(12, 12) scale(0.85) translate(-12, -12)">
                  <g transform="translate(3.2, -1.2)">
                    <path fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M16.785 10.8h-13.8L3.981 8h13.8l-.996 2.8Zm-.498 1.4h-13.8L1.49 15h13.8l.996-2.8Zm-1.491 4.2H.995L0 19.2h13.8l.995-2.8Z"
                          fill="#0663ef" />
                  </g>
                </g>
              </svg>
              <span>Pay</span>
            </v-btn>
          </div>
        </div>

        <div class="mt-3">
          <v-btn
            :disabled="!receiptPdf"
            width="150"
            class="d-inline-block blue-button"
            :class="{ 'button-font': currentLocale === 'tat' }"
            @click="downloadEpd"
            :loading="loading || loadingReceiptPdf"
            >{{ $t("pages.paymentsCurrent.downloadEpd") }}</v-btn
          >
        </div>
        <modal-payment
          v-if="showModalPayment"
          v-model="showModalPayment"
          :to-pay="prePayment == 0 ? toPay : prePayment"
          :energyPay="energyPay"
        />
      </v-col>
    </v-row>

    <modal-spd v-model="showModalSpd" />
    <ModalCertificate v-model="showModalCertificate" @ok="proceedToPayment" />
    <modal-payment-by-providers
      :month="currentReceipt.month"
      :year="currentReceipt.year"
      v-model="showModalPaymentByProviders"
    />
    <ModalNotOwnerNotification
      v-model="showModalNotOwnerNotification"
      @openSubscribeModal="openSubscribeModal"
    />
    <modal-payment-limit v-model="showModalPaymentLimit"
      :message="currentLocale === 'ru' ? isBillingLimitPayment.mesHtml : isBillingLimitPayment.mesTatHtml"
      :header="currentLocale === 'ru' ? isBillingLimitPayment.headerHtml : isBillingLimitPayment.headerTatHtml">
    </modal-payment-limit>
  </div>
</template>

<script>
// import "viewerjs/dist/viewer.css";
import { mapState, mapGetters } from "vuex";

import { AxiosWrapper } from "../../../assets/api/AxiosWrapper";

// node_modules component
import Viewer from "v-viewer/src/component";

// components
import Receipt from "../../../components/payments/current/Receipt";
import PaymentBtn from "../../../components/common/PaymentBtn";
import PersonalAccountSelect from "../../../components/common/PersonalAccountSelect";
import LoaderWrapper from "../../../components/common/LoaderWrapper";
import VCurrencyField from "../../../components/common/VCurrencyField";
import ModalSpd from "../../../components/modals/ModalSpd";
import ModalPayment from "../../../components/modals/ModalPaymentNew";
import ModalPaymentByProviders from "../../../components/modals/ModalPaymentByProviders";
import ModalNotOwnerNotification from "../../../components/modals/ModalNotOwnerNotification";
import ModalPaymentLimit from "../../../components/modals/ModalPaymentLimit.vue";
import ModalCertificate from "../../../components/modals/ModalCertificate.vue";

export default {
  components: {
    ModalPaymentByProviders,
    ModalPayment,
    ModalSpd,
    VCurrencyField,
    LoaderWrapper,
    PersonalAccountSelect,
    PaymentBtn,
    Receipt,
    Viewer,
    ModalNotOwnerNotification,
    ModalPaymentLimit,
    ModalCertificate
  },
  layout: "main",
  data: () => ({
    loading: false,
    loadingReceiptPdf: false,
    prePayment: 0,
    toPay: 0,
    showModalSpd: false,
    showModalPayment: false,
    showModalPaymentByProviders: false,
    showModalNotOwnerNotification: false,
    showNoDataText: false,
    energyPay: false,
    showModalPaymentLimit: false,
    windowSize: {
      x: 0,
      y: 0
    },
    showModalCertificate: false
  }),
  mounted() {
    this.$store.dispatch("payments/getBillingLimitPeriod");
    this.onResize();
  },
  computed: {
    ...mapState("account", ["accounts", "accountInfo", "selectedAccount", "userSettings"]),
    ...mapState("payments", ["currentReceipt", "receiptPdf", "isBillingLimitPayment"]),
    ...mapState("common", ["isOnline"]),
    ...mapGetters("locale", ["currentLocale"]),
    receiptImageSource() {
      return this.currentReceipt && this.currentReceipt.hasOwnProperty("file") && this.currentReceipt.file
        ? "data:image/png;base64," + this.currentReceipt.file
        : "";
    }
  },
  methods: {
    async GetVTBUrl(testMode = false) {
      console.log(this.selectedAccount)
      try {
        const url = 'https://online.vtb.ru/i/pay/id/fc0cd01a-86e6-48a7-9a5a-5e9934187542?PHONE=' + this.selectedAccount.domHoz;
        window.open(url, '_blank');
        await AxiosWrapper.post('TrackVtbClick')
        console.log('Клик зарегистрирован');
      } catch (error) {
        console.error('Ошибка:', error);
      } finally {
        this.loading = false;
      }
    },
    doPay() {
      this.showModalCertificate = true;
    },
    proceedToPayment() {
      this.showModalPaymentLimit = this.isBillingLimitPayment.value;
      if (!this.showModalPaymentLimit) this.showModalPayment = true;
    },
    onCertificateOk() {
      this.showModalCertificate = false;
      this.proceedToPayment();
    },
    downloadEpd() {
      this.showModalPaymentLimit = this.isBillingLimitPayment.value;
      if (this.showModalPaymentLimit) return;

      const link = document.createElement("a");
      link.innerHTML = "Download PDF file";
      link.download = `${this.currentReceipt.month}_${this.currentReceipt.year}.pdf`;
      link.href = "data:application/pdf;base64," + this.receiptPdf;
      link.click();
    },
    openModalPaymentByProviders() {
      this.showModalPaymentByProviders = true;
    },
    openModalNotOwnerNotification() {
      this.showModalNotOwnerNotification = true;
    },
    openSubscribeModal() {
      let ownerAccount;

      let ownerAcc = this.accounts.find(item => item.isOwner);
      if (ownerAcc) ownerAccount = ownerAcc;

      this.$store.dispatch("account/selectPersonalAccount", ownerAccount).then(() => {
        this.showModalSpd = true;
      });
      this.$store.dispatch("indication/loadDevices");
    },
    onResize() {
      this.windowSize = {
        x: window.innerWidth,
        y: window.innerHeight
      };
    }
  },
  watch: {
    selectedAccount: {
      immediate: true,
      handler: function(value) {
        this.loading = true;
        this.showNoDataText = false;
        this.$store
          .dispatch("payments/getCurrentReceipt", {
            domHoz: value.domHoz
          })
          .finally(() => {});

        Promise.all([this.$store.dispatch("account/getAccountInfo")]).finally(() => {
          this.energyPay = this.accountInfo.energyPay;
          this.loading = false;
        });
      }
    },
    currentReceipt(value) {
      this.loadingReceiptPdf = true;
      this.loading = true;
      this.showNoDataText = !value.file;
      this.prePayment = Number(value.prePayment).toFixed(2) < 0 ? 0 : Number(value.prePayment).toFixed(2);
      this.toPay = value.toPay;
      this.$store
        .dispatch("payments/getReceiptPdf", {
          domHoz: this.selectedAccount.domHoz
        })
        .finally(() => {
          this.loadingReceiptPdf = false;
          this.loading = false;
        });
    },
    isOnline(value) {
      if (value) {
        this.loading = true;

        this.$store
          .dispatch("payments/getCurrentReceipt", {
            domHoz: this.selectedAccount.domHoz
          })
          .finally(() => (this.loading = false));
      }
    }
  },
  filters: {
    humanReadableDate(currentReceipt) {
      let date = new Date();
      return (
        [
          "Январь",
          "Февраль",
          "Март",
          "Апрель",
          "Май",
          "Июнь",
          "Июль",
          "Август",
          "Сентябрь",
          "Октябрь",
          "Ноябрь",
          "Декабрь"
        ][currentReceipt.month - 1] +
        " " +
        currentReceipt.year
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../node_modules/viewerjs/dist/viewer.css";

.personal-account {
  display: inline-block;
  margin: 35px 0 0 0;

  &__title {
    @extend %important-text;
    display: inline-block;
    margin-bottom: 10px;
  }
}

.current-main {
  width: 100%;
  position: relative;
  padding: 23px 17px 23px 22px;
  background-color: white;
  border-radius: 5px;

  &__title {
    @extend %h1;
  }
}

.current-piece {
  width: 100%;
  position: relative;
  padding: 23px 17px 23px 22px;
  background-color: white;
  border-radius: 5px;

  &__br {
    display: block;
    font-size: 20px;
  }

  &__title {
    @extend %important-text;
    display: block;
  }

  &__text {
    @extend %text;
    display: block;
  }
}

.current-piece-table {
  padding: 30px 0;
}

.footer-controller {
  display: flex;
  justify-content: flex-end;
}

.receipt-image {
  width: 100%;
  max-height: 800px;
  object-fit: contain;
  padding: 20px;
}
.button-font {
  font-family: Rubik-Medium !important;
  white-space: normal;
}

.vtb-button-cont {
  flex: 0 0 50%;
  border-right: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.vtb-button {
  justify-content: center;
  margin: 0 auto;
  text-align: center;
  align-items: center;
  padding: 10px;
  display: flex;
  height: auto;
  // width: 300px;
  // background: #0663ef;
  background: linear-gradient(#0071bc, #0000ff) !important;
  color: white !important;
  font-family: HelveticaNeueCyr !important;
  text-transform: none !important;
  font-size: 16px !important;
  color: white;
}

@media (max-width: 768px) {
  .vtb-button {
    width: 100%;
    height: auto;
  }
}

</style>
